import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const HeroSlider = () => {
  const [slides, setSlides] = useState([]);

  // Function to convert Google Drive URL to direct image link
  const getDirectImageURL = (imageId) =>
    `https://lh3.googleusercontent.com/d/${imageId}`;
    // `https://drive.google.com/uc?export=view&id=${imageId}`;

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const response = await fetch('https://goforen.com/go_foren/get_slider_data/');
        const data = await response.json();

        // Transform API data to fit slide structure
        const formattedSlides = data.map((item) => ({
          image: getDirectImageURL(item.image_id),
          title: item.heading,
          description: item.sub_heading,
        }));

        setSlides(formattedSlides);
      } catch (error) {
        console.error('Error fetching slider data:', error);
      }
    };

    fetchSlides();
  }, []);

  return (
    <Swiper
      modules={[Autoplay]}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      loop={true}
      className="hero-slider"
    >
      {slides.map((slide, index) => (
        <SwiperSlide key={index}>
          <section
            className="hero hero__style-one bg_img"
            style={{
              backgroundImage: `url(${slide.image})`,
              position: 'relative',
            }}
          >
            <div className="container">
              <div className="row align-items-center">
                <div className="col-xl-6 col-lg-7">
                  <div className="hero__content">
                   <h1 
  className="skewIn" 
  style={{ 
    color: '#000', 
    fontSize: window.innerWidth < 768 ? '21px' : '48px' 
  }}
>
  {slide.title}
</h1>

                    <p
  className="fadeInUp bordertext"
  data--delay="200ms"
  data--duration=".6s"
  style={{ 
    color: '#000',
    fontSize: 'clamp(10px, 3vw, 16px)' 
  }}
>
  {slide.description}
</p>

                    <div
                      className="btns fadeInUp mt-5"
                      data--delay="600ms"
                      data--duration=".6s"
                    >
                      <a
                        className="thm-btn thm-btn--white searchuniversity"
                        href="/Vacancies"
                        style={{
                          background: '#f09318',
                          color: '#fff',
                        }}
                      >
                        Search Job
                      </a>
                      &nbsp;&nbsp;
                      <a
                        className="thm-btn thm-btn--white searchuniversity"
                        href="/StudyCourse"
                      >
                        Search Uni/College
                      </a>
                      &nbsp;&nbsp;
                      <a
                        className="thm-btn thm-btn--white searchuniversity"
                        href="/Contact"
                      >
                        Book Appointment
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default HeroSlider;
